import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpContentText: {
    defaultMessage:
      'Upload a CSV file to import purchase orders. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>',
    id: 'B1sHDS',
    description: 'Purchase Order Import help content text',
  },
  uploadFile: {
    id: '8cjYM6',
    defaultMessage: 'Upload File',
    description: 'Title for the first step of the import process',
  },
  selectInventoryWarehouse: {
    id: '4phw2W',
    defaultMessage: 'Select inventory warehouse',
    description: 'Label for the dropdown to select the inventory warehouse',
  },
  selectInventoryWarehouseHeader: {
    id: '1dFfEM',
    defaultMessage: 'Select warehouse to apply import to',
    description: 'Label for the header to select the inventory warehouse',
  },
});
